const IS_GOTENBERG_PRINTING =
  typeof window !== 'undefined' ? window.location?.search?.includes('gotenbergPrint') : false;

const IS_IFRAME_EMBED =
  typeof window !== 'undefined' ? window.location?.pathname?.includes('/embeds') : false;

export { IS_GOTENBERG_PRINTING, IS_IFRAME_EMBED };
